<template>
    <div class="main">
        <c-panel>
            <pendencias></pendencias>
        </c-panel>
    </div>
</template>
<script>

import pendencias from "./pendencias"

export default {
    components:{ pendencias }
}
</script>
